import { Text, View } from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';

const RoomSettings = () => {
  const { drawerWidth } = useAppStore();

  return (
    <View
      as="div"
      maxWidth={drawerWidth}
      minWidth={drawerWidth}
      textAlign="center"
      margin="large auto"
      padding="large"
    >
      <Text>Room Settings Coming Soon!</Text>
    </View>
  );
};

export default RoomSettings;
